// extracted by mini-css-extract-plugin
export var cardIcon = "_7v-5";
export var checkboxCard = "_7v-0";
export var checkboxCardSelected = "_7v-4";
export var disabled = "_7v-2";
export var interactive = "_7v-1";
export var outerBorder = "_7v-3";
export var spacerMedium = "_7v-8";
export var spacerSmall = "_7v-7";
export var spacerXsmall = "_7v-6";